import React from 'react';

const ModuleNavigation = ({ modules, activeId, onNavigate, isZh = false }) => (
    <nav className="ai-dev-module-nav" aria-label={isZh ? '监测模块' : 'Monitor modules'}>
        <div className="ai-dev-module-nav__inner">
            {modules.map((module, index) => (
                <a
                    key={module.id}
                    href={`#${module.id.replaceAll('_', '-')}`}
                    className={activeId === module.id ? 'is-active' : ''}
                    aria-current={activeId === module.id ? 'location' : undefined}
                    onClick={() => onNavigate?.(module.id)}
                >
                    <span>{index + 1}</span>
                    {isZh ? module.labelZh : module.label}
                </a>
            ))}
        </div>
    </nav>
);

export default ModuleNavigation;
